import { Children, isValidElement, PropsWithChildren, ReactNode, useMemo } from 'react';

import { Slot } from './slot';
import { SlotProps } from './slot.types';

function warnOnAmbiguousSlot(name: string) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(
      `Slot "${name}": both \`children\` and \`render\` were provided; \`children\` takes precedence.`,
    );
  }
}

export function useSlots({ children }: PropsWithChildren) {
  return useMemo(() => {
    const slots: Record<string, ReactNode> = {};

    Children.forEach(children, (child) => {
      if (!isValidElement<SlotProps>(child) || child.type !== Slot) return;

      const { name, children: slotChildren, render } = child.props;

      if (slotChildren != null && render != null) warnOnAmbiguousSlot(name);

      const content = slotChildren ?? render;
      if (content != null) slots[name] = content;
    });

    return slots;
  }, [children]);
}
